import React, { useContext } from 'react';
import { Button, Space, Upload, message, Divider, Typography } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { DeclarationContext } from '../context/DeclarationWrapper';

const { Text } = Typography;

const DsnFileUpload = () => {
  const { dsnFile, updateDsnFile } = useContext(DeclarationContext);

  const handleFileChange = (info) => {
    const file = info.file;

    // Valider le type de fichier
    const isValidType = ['application/pdf', 'application/xml', 'text/xml', 'text/plain'].includes(file.type);
    if (!isValidType) {
      message.error('Seuls les fichiers PDF, XML et TXT sont acceptés !');
      return;
    }

    // Valider la taille (10 MB max)
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      message.error('Le fichier ne doit pas dépasser 10 MB !');
      return;
    }

    updateDsnFile(file);
  };

  return (
    <div style={{ marginTop: 16 }}>
      <Divider orientation="left">Fichier DSN</Divider>
      {dsnFile ? (
        <Space size="middle">
          <Text strong>{dsnFile.name}</Text>
          <Upload
            beforeUpload={(file) => {
              handleFileChange({ file });
              return false;
            }}
            showUploadList={false}
            accept=".pdf,.xml,.txt"
          >
            <Button icon={<UploadOutlined />}>
              Changer de fichier
            </Button>
          </Upload>
        </Space>
      ) : (
        <Text type="secondary">Aucun fichier DSN sélectionné</Text>
      )}
    </div>
  );
};

export default DsnFileUpload;
